import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {first, map} from 'rxjs/operators';
import {SessionQuery, SessionService} from '../state/session';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(
    private sessionQuery: SessionQuery,
    private sessionService: SessionService,
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {
    return this.sessionQuery.loading$.pipe(
      first(loading => !loading),
      map(() => {
        if (this.sessionQuery.getValue().user) {
          return true;
        }

        // Немає користувача (не автентифікований або /account не відповів) — на логін.
        // login(), а не logout(): при живій SSO-сесії Keycloak поверне користувача без пароля.
        this.sessionService.redirectToLogin();
        return false;
      }),
    );
  }

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(next, state);
  }
}
